import { combineReducers } from "redux";
import Layout from "./layouts/reducer";
import Login from "./auth/login/reducer";
import Account from "./auth/register/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import Profile from "./auth/profile/reducer";
import Team from "./team/reducer";
import EmployeeReducer from "./getEmployee/reducer"
import IndustryTypeData from "./CallType/reducer";
import teamReducer from "./teams/reducer";
import LeadReducer from "./leadManagement/reducer";
import { fetchEmployeeReducer } from "./FetchEmployees/reducer";
import { leadStatusReducer } from "./FetchLeadStatus/reducer";
const rootReducer = combineReducers({
    leadStatusReducer,
    fetchEmployeeReducer,
    LeadReducer,
    EmployeeReducer,
    IndustryTypeData,
    Layout,
    Login,
    Account,
    ForgetPassword,
    Profile,
    Team,
    teamReducer,
});

export default rootReducer;